import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import {
  PublicWifiPxsplusGetConfigureUrlEntity,
  PublicWifiPxsplusProductsEntity,
} from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class PublicWifiPxsplusService {
  constructor() {}

  getProducts(): Observable<IEntity<any>> {
    return EntityManager.getEntity(PublicWifiPxsplusProductsEntity);
  }

  getConfigureURL(payload: any): Observable<IEntity<any>> {
    PublicWifiPxsplusGetConfigureUrlEntity.customHeaders = {
      ...PublicWifiPxsplusGetConfigureUrlEntity.customHeaders,
      'x-application-authorization-products-data': payload.jwt,
    };
    return EntityManager.getEntity(PublicWifiPxsplusGetConfigureUrlEntity, {
      serviceId: payload.serviceId,
      deviceOsVersion: 1.1, // mandatory but not used on backend side
      abroad: 'false',
      filter: 'smartwifi',
      deviceOperatingSystem: 'IOS',
    });
  }
}
